<template>
  <b-modal
    id="land-purchase-data-modal"
    ref="land-purchase-data-modal"
    title="Select Land Purchase"
    size="xl"
    ok-title="Submit"
    @ok="handleSubmit"
    @hidden="resetModal"
    dialog-class="land-purchase-modal"
    content-class="land-purchase-modal-content"
    body-class="land-purchase-modal-body"
  >
    <!-- <div class="excel-header mb-2">
      <h5 class="mb-0 font-weight-bold">DHOLERA SIR ALL LAND </h5>
    </div> -->
    <div class="table-container">
      <b-table
        ref="landPurchaseTable"
        :items="landPurchaseItems"
        :fields="fields"
        :busy="isBusy"
        class="excel-table"
        show-empty
        bordered
        small
        hover
        responsive
        :tbody-tr-class="getRowClass"
      >
      <template #cell(select)="data">
        <b-form-checkbox
          :checked="selected && selected.id === data.item.id"
          @change="handleCheckboxChange(data.item)"
        />
      </template>
      <template #cell(srNo)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(zone)="data">
        <span 
          class="zone-badge"
          :style="{ 
            backgroundColor: getZoneColor(data.value || data.item.zone), 
          }"
        >
          {{ data.value || data.item.zone || '-' }}
        </span>
      </template>
      <template #cell(remark)="data">
        <span 
          class="remark-badge"
          :style="{ backgroundColor: getRemarkColor(data.item.remark) }"
        >
          {{ data.value || '-' }}
        </span>
      </template>
      <template #cell(rate)="data">
        <span v-if="!isSoldOut(data.item)">
          {{ data.value || '-' }}
        </span>
      </template>
      <template #cell(proposal)="data">
        <span v-if="!isSoldOut(data.item) && (data.item.proposal || data.item.landProposal)" class="text-link" @click="openFile(data.item.proposal || data.item.landProposal)">
          Proposal
        </span>
        <span v-else-if="!isSoldOut(data.item)">-</span>
      </template>
      <template #cell(kml)="data">
        <span v-if="!isSoldOut(data.item) && (data.item.kml || data.item.kmzFile || data.item.kmzfile)" class="text-link" @click="openKMLFile(data.item.kml || data.item.kmzFile || data.item.kmzfile)">
          KML
        </span>
        <span v-else-if="!isSoldOut(data.item)">-</span>
      </template>
      <template #cell(tpMap)="data">
        <span v-if="!isSoldOut(data.item) && (data.item.tpMap || data.item.mapImage || data.item.mapimage)" class="text-link" @click="openMapImage(data.item.tpMap || data.item.mapImage || data.item.mapimage)">
          TP MAP
        </span>
        <span v-else-if="!isSoldOut(data.item)">-</span>
      </template>
      <template #cell(naStatus)="data">
        <span v-if="!isSoldOut(data.item)">
          {{ formatNAStatus(data.value || data.item.naStatus) }}
        </span>
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BTable,
  BSpinner,
  BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BModal,
    BTable,
    BSpinner,
    BFormCheckbox,
  },
  data() {
    return {
      fields: [
        { key: 'select', label: '', thClass: 'select-col', tdClass: 'select-col' },
        { key: 'srNo', label: 'SR No.' },
        { key: 'trNo', label: 'Tr. No.', thClass: 'trno-col', tdClass: 'trno-col' },
        { key: 'village', label: 'Village', thClass: 'village-col', tdClass: 'village-col' },
        { key: 'newSurveyNo', label: 'New Survey No.' },
        { key: 'oldNo', label: 'Old No.' },
        { key: 'fpNo', label: 'FP NO' },
        { key: 'subTp', label: 'SUB TP' },
        { key: 'zone', label: 'Zone' },
        { key: 'tpRoad', label: 'TP ROAD' },
        { key: 'fpArea', label: 'FP AREA - SQ. YARD', thClass: 'fparea-col', tdClass: 'fparea-col' },
        { key: 'rate', label: 'RATE - PER SQ. YARD', thClass: 'rate-col', tdClass: 'rate-col' },
        { key: 'proposal', label: 'Proposal', thClass: 'proposal-col', tdClass: 'proposal-col' },
        { key: 'kml', label: 'KML', thClass: 'kml-col', tdClass: 'kml-col' },
        { key: 'tpMap', label: 'TP MAP', thClass: 'tpmap-col', tdClass: 'tpmap-col' },
        { key: 'naStatus', label: 'NA STATUS', thClass: 'nastatus-col', tdClass: 'nastatus-col' },
        { key: 'remark', label: 'REMARK', thClass: 'remark-col', tdClass: 'remark-col' },
      ],
      landPurchaseItems: [],
      isBusy: false,
      selected: null,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      imagePath: process.env.VUE_APP_IMAGE_PATH || '',
    }
  },
  mounted() {
    this.fetchLandPurchaseData();
  },
  methods: {
    async fetchLandPurchaseData() {
      this.isBusy = true
      // This endpoint should return land purchase data.
      // You may need to adjust it based on your API.
      await axios({
        method: "GET",
        url: `${this.baseApi}/getlandpurchasealldata`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.landPurchaseItems = json.data.data.data
          // Debug: Log first item to check field names
          if (this.landPurchaseItems && this.landPurchaseItems.length > 0) {
            console.log('Sample item fields:', Object.keys(this.landPurchaseItems[0]))
            console.log('Proposal field:', this.landPurchaseItems[0].proposal || this.landPurchaseItems[0].landProposal)
            console.log('KML field:', this.landPurchaseItems[0].kml || this.landPurchaseItems[0].kmzFile || this.landPurchaseItems[0].kmzfile)
            console.log('TP Map field:', this.landPurchaseItems[0].tpMap || this.landPurchaseItems[0].mapImage || this.landPurchaseItems[0].mapimage)
            console.log('NA Status:', this.landPurchaseItems[0].naStatus)
          }
          this.isBusy = false
        })
        .catch((error) => {
          console.error(error)
          this.isBusy = false
        });
    },
    handleCheckboxChange(item) {
      if (this.selected && this.selected.id === item.id) {
        this.selected = null;
      } else {
        this.selected = item;
      }
    },
    handleSubmit() {
      if(this.selected) {
        this.$emit('land-purchase-selected', this.selected)
      }
      this.$refs['land-purchase-data-modal'].hide()
    },
    resetModal() {
      this.selected = null
    },
    getZoneColor(zone) {
      if (!zone) {
        return 'transparent'
      }
      // Normalize zone value: trim whitespace and convert to lowercase
      const normalizedZone = String(zone).trim().toLowerCase()
      
      // Remove " zone" suffix if present
      const zoneWithoutSuffix = normalizedZone.replace(/\s+zone$/, '')
      
      // Zone color mapping based on keywords
      // Residential zones
      if (zoneWithoutSuffix.includes('residential')) {
        return '#fff3cd' // Yellow
      }
      
      // Industrial zones
      if (zoneWithoutSuffix.includes('industrial')) {
        return '#e7d3ff' // Purple
      }
      
      // High Access Corridor (HAC)
      if (zoneWithoutSuffix.includes('high access corridor') || 
          zoneWithoutSuffix.includes('hac')) {
        return '#ffe5cc' // Orange
      }
      
      // MultiPurpose and other zones (default to green)
      // This includes: Recreation, Sports & Entertainment, Tourism & Resort, 
      // City Center, IT & Knowledge, etc.
      return '#d4edda' // Green
    },
    getRemarkColor(remark) {
      if (!remark) return 'transparent'
      const remarkColors = {
        'AVAILABLE': '#d4edda',
        'SOLD OUT': '#f8d7da',
      }
      return remarkColors[remark] || 'transparent'
    },
    formatNAStatus(status) {
      if (!status) return ''
      // Convert yes/no to R*/A* format to match Excel
      // R* = "Residential" or "Ready" (yes/1/true)
      // A* = "Agricultural" or "Available" (no/0/false)
      const statusStr = String(status).toLowerCase().trim()
      
      // Check for R* indicators (Residential/Ready)
      if (statusStr === 'yes' || statusStr === '1' || statusStr === 'true' || statusStr === 'r+' || statusStr === 'r*') {
        return 'R*'
      }
      
      // Check for A* indicators (Agricultural/Available)
      if (statusStr === 'no' || statusStr === '0' || statusStr === 'false' || statusStr === 'a+' || statusStr === 'a*') {
        return 'A*'
      }
      
      // If already in R*/A* format (case-insensitive), return uppercase
      if (statusStr === 'r*' || statusStr === 'a*') {
        return statusStr.toUpperCase()
      }
      
      // If already in R*/A* format, return as is
      return status
    },
    openFile(filePath) {
      if (!filePath) return
      const fullPath = filePath.includes(this.imagePath) ? filePath : this.imagePath + filePath
      window.open(fullPath, '_blank')
    },
    openKMLFile(filePath) {
      if (!filePath) return
      const fullPath = filePath.includes(this.imagePath) ? filePath : this.imagePath + filePath
      // KML/KMZ files can be opened in new window or downloaded
      window.open(fullPath, '_blank')
    },
    openMapImage(filePath) {
      if (!filePath) return
      const fullPath = filePath.includes(this.imagePath) ? filePath : this.imagePath + filePath
      // Open map image in new window
      window.open(fullPath, '_blank')
    },
    isSoldOut(item) {
      return item && item.remark === 'SOLD OUT'
    },
    getRowClass(item, type) {
      if (!item || type !== 'row') return ''
      if (this.isSoldOut(item)) {
        return 'sold-out-row'
      }
      return ''
    },
  },
}
</script>

<style scoped>
.land-purchase-modal {
  max-width: 95vw;
}

.land-purchase-modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.land-purchase-modal-body {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.excel-header {
  padding: 0.5rem 0;
  border-bottom: 2px solid #dee2e6;
}

.table-container {
  overflow-x: auto;
  overflow-y: auto;
  flex: 1;
  max-height: calc(90vh - 200px);
  width: 100%;
}

.excel-table {
  font-size: 0.75rem;
  width: 100%;
  table-layout: auto;
  margin-bottom: 0;
}

.excel-table ::v-deep thead th {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 0.5rem;
  font-weight: 600;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  position: sticky;
  top: 0;
  z-index: 10;
  line-height: 1.3;
}

.excel-table ::v-deep tbody td {
  border: 1px solid #dee2e6;
  padding: 0.4rem;
  vertical-align: middle;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* No wrap for Tr No., Village, and Proposal */
.excel-table ::v-deep .trno-col,
.excel-table ::v-deep .village-col,
.excel-table ::v-deep .proposal-col {
  white-space: nowrap;
  word-wrap: normal;
  word-break: normal;
  overflow-wrap: normal;
}

/* Width for FP AREA and RATE columns */
.excel-table ::v-deep .fparea-col,
.excel-table ::v-deep .rate-col {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/* Header can wrap for FP AREA and RATE, but data cells should not wrap */
.excel-table ::v-deep thead th.fparea-col,
.excel-table ::v-deep thead th.rate-col {
  white-space: normal;
  word-wrap: break-word;
}

.excel-table ::v-deep tbody td.fparea-col,
.excel-table ::v-deep tbody td.rate-col {
  white-space: nowrap;
}

/* Width for KML and REMARK columns based on heading text */
.excel-table ::v-deep .kml-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  text-align: center;
}

.excel-table ::v-deep .remark-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  text-align: center;
}

.excel-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5;
}

/* Red background for specific columns when remark is SOLD OUT */
.excel-table ::v-deep tbody tr.sold-out-row td.rate-col,
.excel-table ::v-deep tbody tr.sold-out-row td.proposal-col,
.excel-table ::v-deep tbody tr.sold-out-row td.kml-col,
.excel-table ::v-deep tbody tr.sold-out-row td.tpmap-col,
.excel-table ::v-deep tbody tr.sold-out-row td.nastatus-col,
.excel-table ::v-deep tbody tr.sold-out-row td.remark-col {
  background-color: #d51829;
}

/* Also apply to cells by nth-child for columns without classes */
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(12),
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(13),
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(14),
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(15),
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(16),
.excel-table ::v-deep tbody tr.sold-out-row td:nth-child(17) {
  background-color: #d51829;
}

/* Column alignment */
.excel-table ::v-deep tbody td:nth-child(2),
.excel-table ::v-deep thead th:nth-child(2) {
  text-align: center;
}

.excel-table ::v-deep tbody td:nth-child(3),
.excel-table ::v-deep thead th:nth-child(3) {
  text-align: center;
}

.excel-table ::v-deep tbody td:nth-child(7),
.excel-table ::v-deep thead th:nth-child(7),
.excel-table ::v-deep tbody td:nth-child(8),
.excel-table ::v-deep thead th:nth-child(8) {
  text-align: center;
}

.excel-table ::v-deep tbody td:nth-child(9),
.excel-table ::v-deep thead th:nth-child(9) {
  text-align: center;
}

.excel-table ::v-deep tbody td:nth-child(11),
.excel-table ::v-deep thead th:nth-child(11),
.excel-table ::v-deep tbody td:nth-child(12),
.excel-table ::v-deep thead th:nth-child(12) {
  text-align: right;
}

.excel-table ::v-deep tbody td:nth-child(13),
.excel-table ::v-deep thead th:nth-child(13),
.excel-table ::v-deep tbody td:nth-child(14),
.excel-table ::v-deep thead th:nth-child(14),
.excel-table ::v-deep tbody td:nth-child(15),
.excel-table ::v-deep thead th:nth-child(15),
.excel-table ::v-deep tbody td:nth-child(16),
.excel-table ::v-deep thead th:nth-child(16),
.excel-table ::v-deep tbody td:nth-child(17),
.excel-table ::v-deep thead th:nth-child(17) {
  text-align: center;
}

.zone-badge {
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 0.7rem;
}

.remark-badge {
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 500;
}

.text-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}

.text-link:hover {
  color: #0056b3;
}

/* Scrollbar styling */
.table-container::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
